// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Component, GondelBaseComponent } from '@gondel/core';
/**
 * cookie-consent-banner module implementation.
 * @author Danijel Malinovic <danijel.malinovic@emea.merkleinc.com>
 */

enum States {
	Visible = 'state-m-cookie-consent-banner--visible',
}

@Component('CookieConsentBanner')
export class CookieConsentBanner extends GondelBaseComponent {
	private readonly _requiredCookieCategory: string = 'C0004';

	public start() {
		this._initializeOneTrust();
	}

	private _initializeOneTrust() {
		this._ctx.onclick = this._onCookieNoticeClick.bind(this);

		window.addEventListener('onetrust.init', () => {
			this._checkCookieNoticeVisibility();

			 
			window.Optanon.OnConsentChanged(() => {
				this._checkCookieNoticeVisibility();
			});
		});
	}

	 
	private _onCookieNoticeClick(evt: Event): void {
		evt.preventDefault();

		if (!window.Optanon || !(typeof window.Optanon.ToggleInforDisplay === 'function')) {
			return false;
		}

		window.Optanon.ToggleInfoDisplay();
	}

	private _getCookieNoticeState() {
		if (!window.Optanon) {
			return false;
		}

		const allowedCookies = window.OptanonActiveGroups || '';
		const allowedCookiesArray = allowedCookies.split(',');

		return allowedCookiesArray.indexOf(this._requiredCookieCategory) < 0;
	}

	private _checkCookieNoticeVisibility() {
		const showCookieNotice = this._getCookieNoticeState();

		if (showCookieNotice) {
			this._ctx.classList.add(States.Visible);
		} else {
			this._ctx.classList.remove(States.Visible);
		}
	}

	 
}
